import React from "react";
import { FlowCard } from "./FlowCard";

export function FlowPanel({
  item,
  panelIndex,
  positionClass,
  panelClassName,
  isActive,
  onOpen,
  onClose,
  onMore,
  onAddToBasket,
  isItemInBasket,
}) {
  return (
    <div
      data-panel-index={panelIndex}
      className={`g-flow__panel${panelClassName ? ` ${panelClassName}` : ""}`}
      js-flow-item="true"
    >
      <FlowCard
        item={item}
        positionClass={positionClass}
        isActive={isActive}
        onOpen={onOpen}
        onClose={onClose}
        onMore={onMore}
        onAddToBasket={onAddToBasket}
        isItemInBasket={isItemInBasket}
      />
    </div>
  );
}
